import axios from "../axios";
import { AxiosResponse } from "axios";
import { GraphType } from "../components/targets/Target";
import { Page } from "../utils/types/dataTypes";

type DocumentResponse = {
	succeed: boolean;
	goals: {
		id: string; // this is document id
		goals: Goal[];
		pagesPerSession: number;
		sessionTime: number;
		uniqueVisitors: number;
		visitorsOverTime: VisitorsOverTime[];
		pages: Page[];
		totalDocVisits: number;
	}
};

export type Goal = {
	id: string;
	documentId: string;
	graphType: GraphType;
	target: number;
};

export type Analytics = {
	pagesPerSession: number;
	uniqueVisitors: number;
	sessionTime: number;
	visitorsOverTime: VisitorsOverTime[];
	pages: Page[];
	totalDocVisits: number;
};

export type VisitorsOverTime = {
	id: string;
	timestamp: string;
	amountOfVisitors: number;
	documentId: string;
	day: string;
};

export const getDocumentAnalytics =
	(documentId: string): Promise<AxiosResponse<DocumentResponse>> => {
		return axios.get(`/analytics/${documentId}`);
	};

export const saveDocumentGoal = (goalId: string, target: number) => {
	return axios.post("/goals/", { goalId: goalId, target: target });
};

export const getCorrectAnalytics = (graphType: GraphType, analytics: Analytics): number => {
	switch (graphType) {
	case GraphType.PAGES_PER_SESSION:
		return analytics.pagesPerSession;
	case GraphType.SESSION_TIME:
		return analytics.sessionTime;
	case GraphType.UNIQUE_VISITORS:
		return analytics.uniqueVisitors;
	}
};